define.alias("shared/components/shared/upgrade/trial-monthly-price", "settings/components/shared/upgrade/trial-monthly-price");